module.exports = __webpack_public_path__ + "static/media/TN-Women-Dress.8320d294.svg";